import { requestCreator, UnknownError } from "../../common/actions/VisitApi";

export const requestToCreatePostLike = requestCreator<number, null, UnknownError>(postId => ({
  path: `/api/internal/posts/${postId}/like`,
  method: "POST",
}));

export const requestToDeletePostLike = requestCreator<number, null, UnknownError>(postId => ({
  path: `/api/internal/posts/${postId}/like`,
  method: "DELETE",
}));



// WEBPACK FOOTER //
// ./frontend/src/post_likes/api/index.ts